import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Listbox, Transition } from "@headlessui/react";
import { Fragment } from "react";

const statusOptions = [
  { value: "All", label: "All Statuses" },
  { value: "pending", label: "Pending" },
  { value: "validated", label: "Validated" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

const typeOptions = [
  { value: "All", label: "All Types" },
  { value: "transfer", label: "Transfer" },
  { value: "fund", label: "Funding" },
  { value: "loan", label: "Loan Disbursement" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function TransactionFilters({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  typeFilter,
  setTypeFilter,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  destinationCountry,
  setDestinationCountry,
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:space-x-3 mb-6 gap-3">
      {/* Search */}
      <div className="relative flex-grow">
        <MagnifyingGlassIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
        <input
          type="text"
          placeholder="Search by ID or user email..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full pl-10 pr-3 py-2 rounded-lg border dark:bg-gray-700 dark:text-white"
        />
      </div>

      {/* Date filters */}
      <input
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        className="border rounded-lg px-3 py-2 dark:bg-gray-700 dark:text-white"
      />
      <input
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        className="border rounded-lg px-3 py-2 dark:bg-gray-700 dark:text-white"
      />

      {/* Country */}
      <input
        type="text"
        placeholder="Country..."
        value={destinationCountry}
        onChange={(e) => setDestinationCountry(e.target.value)}
        className="border rounded-lg px-3 py-2 dark:bg-gray-700 dark:text-white"
      />

      {/* Status */}
      <Listbox value={statusFilter} onChange={setStatusFilter}>
        {({ open }) => (
          <div className="relative w-40">
            <Listbox.Button className="w-full rounded-lg border py-2 pl-3 pr-10 dark:bg-gray-700 dark:text-white">
              {statusOptions.find((opt) => opt.value === statusFilter)?.label}
            </Listbox.Button>
            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-700 border rounded-lg shadow-lg max-h-60 overflow-auto">
                {statusOptions.map((option) => (
                  <Listbox.Option
                    key={option.value}
                    value={option.value}
                    className={({ active }) =>
                      classNames(
                        active
                          ? "bg-blue-100 dark:bg-blue-600"
                          : "text-gray-900 dark:text-gray-100",
                        "cursor-pointer select-none relative py-2 pl-3 pr-9"
                      )
                    }
                  >
                    {option.label}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>

      {/* Type */}
      <Listbox value={typeFilter} onChange={setTypeFilter}>
        {({ open }) => (
          <div className="relative w-44">
            <Listbox.Button className="w-full rounded-lg border py-2 pl-3 pr-10 dark:bg-gray-700 dark:text-white">
              {typeOptions.find((opt) => opt.value === typeFilter)?.label}
            </Listbox.Button>
            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-700 border rounded-lg shadow-lg max-h-60 overflow-auto">
                {typeOptions.map((option) => (
                  <Listbox.Option
                    key={option.value}
                    value={option.value}
                    className={({ active }) =>
                      classNames(
                        active
                          ? "bg-blue-100 dark:bg-blue-600"
                          : "text-gray-900 dark:text-gray-100",
                        "cursor-pointer select-none relative py-2 pl-3 pr-9"
                      )
                    }
                  >
                    {option.label}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        )}
      </Listbox>
    </div>
  );
}
